import React from "react";
import PropTypes from "prop-types";
import { LuMic, LuVideo } from "react-icons/lu";
import BetaBadge from "../../common/BetaBadge";
import { tt } from "./talkingAvatarI18n";
import "./_talkingAvatar.scss";

// "Avatar Anlatımı" generation method: the existing lip-sync flow (default) or
// the talking-avatar flow (video + speech generated together, Beta).
const METHODS = [
  {
    id: "lipsync",
    icon: <LuMic size={16} />,
    title: ["TalkingAvatar.Method.Lipsync", "Dudak senkronu"],
    meta: [
      "TalkingAvatar.Method.LipsyncMeta",
      "Avatar videosu seçtiğiniz sesle dudak senkronlanır",
    ],
  },
  {
    id: "talking",
    icon: <LuVideo size={16} />,
    title: ["TalkingAvatar.Method.Talking", "Doğal konuşan video"],
    meta: [
      "TalkingAvatar.Method.TalkingMeta",
      "Video ve konuşma birlikte üretilir; ses seçtiğiniz sese çevrilir",
    ],
    beta: true,
  },
];

export default function TalkingMethodSelector({ value, onChange, disabled }) {
  return (
    <div className="asm-ta__method">
      <div className="asm-ta__method-label">
        {tt("TalkingAvatar.Method.Title", "Üretim yöntemi")}
      </div>
      <div className="asm-av__method-grid asm-ta__method-grid" role="radiogroup">
        {METHODS.map((m) => {
          const on = value === m.id;
          return (
            <button
              key={m.id}
              type="button"
              role="radio"
              aria-checked={on}
              disabled={disabled}
              className={`asm-av__method${on ? " asm-av__method--on" : ""}`}
              onClick={() => {
                if (!on) onChange?.(m.id);
              }}
            >
              <span className="asm-av__method-icon">{m.icon}</span>
              <span className="asm-av__method-title">
                {tt(...m.title)}
                {m.beta && <BetaBadge className="asm-ta__beta" />}
              </span>
              <span className="asm-av__method-meta">{tt(...m.meta)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

TalkingMethodSelector.propTypes = {
  value: PropTypes.oneOf(["lipsync", "talking"]).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
